// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"R5-z","upvote":"S5-z","downvote":"T5-z","numVotes":"U5-z","votesDescription":"V5-z","report":"W5-z","voted":"X5-z","answerVoteBox":"Y5-z","justReported":"Z5-z"};